import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { getEntryPoint } from 'settings/app/helpers'
import {
  checkEnvironmentVarsByProp,
  MAPPED_REDIRECT_KEYS,
} from '../EnvironmentSetter/helper'
import {
  __check_injected_params__,
  __dev__,
  __local_cdn__,
  __prod__,
  PAGE_TYPES,
  searchTypeIds,
} from 'settings/app/constants'

const RedirectContext = React.createContext({})

/**
 * provide client redirects
 * required in productive environment
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
const RedirectProvider = ({ children }) => {
  const { current: entryPointFromStorage } = React.useRef(getEntryPoint())
  const redirectHasChecked = React.useRef(false)
  const [redirectURLs, setRedirectURLs] = useState({})
  const isSeoPage = PAGE_TYPES.SEO_PAGE === localStorage.getItem('pageType')

  /**
   * read all redirect values and set state
   */
  useEffect(() => {
    if (entryPointFromStorage && !isSeoPage) {
      let newRedirects = {}

      if (__dev__) {
        newRedirects = {
          cross: searchTypeIds.CROSS,
          doctors: searchTypeIds.DOCTORS,
          hospitals: searchTypeIds.HOSPITALS,
          midwives: searchTypeIds.MIDWIVES,
          ambulances: searchTypeIds.AMBULANCES,
          oncallservices: searchTypeIds.ONCALLSERVICES,
          caresearch: searchTypeIds.CARESEARCH,
          carehomes: searchTypeIds.CAREHOMES,
          careservices: searchTypeIds.CARESERVICES,
          caresupport: searchTypeIds.CARESUPPORT,
          dayandnightcare: searchTypeIds.DAYANDNIGHTCARE,
        }
      }

      if (__prod__) {
        Object.keys(MAPPED_REDIRECT_KEYS).forEach((key) => {
          let keyValue =
            localStorage.getItem(MAPPED_REDIRECT_KEYS[key]) || false
          if (!!keyValue) {
            if (__local_cdn__) {
              keyValue = keyValue.replace(
                'https://www.aok.de/',
                'http://localhost:9090/'
              )
            }
            newRedirects[key] = keyValue
          }
        })
      }

      if (Object.keys(newRedirects).length) {
        setRedirectURLs((prevState) => ({
          ...prevState,
          ...newRedirects,
        }))
      }
    }
  }, [entryPointFromStorage, isSeoPage, setRedirectURLs])

  /**
   * check redirects
   */
  useEffect(() => {
    if (
      __prod__ &&
      __check_injected_params__ &&
      entryPointFromStorage &&
      !redirectHasChecked.current
    ) {
      checkEnvironmentVarsByProp('redirects', entryPointFromStorage)
      redirectHasChecked.current = true
    }
  }, [entryPointFromStorage])

  return (
    <RedirectContext.Provider value={ redirectURLs }>
      {children}
    </RedirectContext.Provider>
  )
}

// custom hook
const useRedirects = () => {
  const context = React.useContext(RedirectContext)
  if (context === undefined) {
    throw new Error('useMobilSwitch must be used within a MobileSwitchProvider')
  }
  return context
}

RedirectProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export { RedirectProvider, useRedirects }
